import { Box, Icon, MenuItem, MenuList, Paper, Popper } from '@mui/material'
import React, { ReactElement, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getNoHideEntityList } from '../../../utils/NavUtils'
import { useTranslation } from 'react-i18next'
import { NavigateNextSharp } from '@mui/icons-material'
import MemoizedTruncatedText from '../../Common/TruncatedText'
import type { EntityType } from '../../DTStudio/interfaces'

interface SubNavListType {
    anchorElSubNav: HTMLElement | null
    handleCloseSubNav: () => void
    subNavOpen: boolean
    list: EntityType[]
}
const SubNavList = (props: SubNavListType): ReactElement => {
    const { list, anchorElSubNav, handleCloseSubNav, subNavOpen } = props
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [anchorElchildNav, setAnchorElchildNav] =
        React.useState<null | HTMLElement>(null)
    const [activeSubNavId, setActiveSubNavId] = useState<string | null>(null)
    const navList = useMemo(() => {
        return getNoHideEntityList(list)
    }, [list])
    const handleClickchildNav = (
        event: React.MouseEvent<HTMLElement>,
        id: string,
    ) => {
        setAnchorElchildNav(event.currentTarget)
        setActiveSubNavId((prev) => (prev === id ? null : id))
    }
    useEffect(() => {
        if (!subNavOpen) {
            setAnchorElchildNav(null)
            setActiveSubNavId(null)
        }
    }, [subNavOpen])

    return (
        <Popper
            id="setup-sub-menu"
            anchorEl={anchorElSubNav}
            open={subNavOpen}
            placement="right-start"
            sx={{
                zIndex: (theme) => theme.zIndex.modal,
            }}
        >
            <Paper
                elevation={8}
                data-sub-nav-menu="true"
                aria-label={t('subNavigationMenu')}
                aria-labelledby={anchorElSubNav ? anchorElSubNav.id : undefined}
            >
                <MenuList role="menu">
                    {navList?.map((item, index: number) => (
                        <React.Fragment key={item.id ?? item.name ?? index}>
                            <Box
                                role="none"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <MenuItem
                                    id={item.name}
                                    onClick={() => {
                                        handleCloseSubNav()
                                        navigate(
                                            `/entity/${item.name}/${item.id}`,
                                        )
                                    }}
                                    role="menuitem"
                                    title={t('goTo', { itemName: item.name })}
                                    aria-label={t('navigateTo', {
                                        itemName: item.name,
                                    })}
                                    sx={{
                                        width: '160px',
                                        filter: 'brightness(0)',
                                        opacity: '0.6',
                                    }}
                                >
                                    {/* <Typography
                                        variant="h5"
                                        sx={{
                                            width: '160px',
                                            textOverflow: 'ellipsis',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        {item.name}
                                    </Typography> */}
                                    <MemoizedTruncatedText
                                        variant="h6"
                                        text={t(item.name)}
                                    />
                                </MenuItem>
                                {item.subEntityTypes?.length > 0 ? (
                                    <Icon
                                        id={`${item.name}-sub-menu-button`}
                                        data-sub-nav-trigger="true"
                                        onClick={(event) =>
                                            handleClickchildNav(event, item.id)
                                        }
                                        aria-label={t('expandSubMenuFor', {
                                            itemName: item.name,
                                        })}
                                        title={t('expandSubMenuFor', {
                                            itemName: item.name,
                                        })}
                                        sx={{
                                            minWidth: 24,
                                            paddingRight: '30px',
                                            cursor: 'pointer',
                                            zIndex: 2,
                                            filter: 'brightness(0)',
                                            opacity: '0.4',
                                        }}
                                    >
                                        <NavigateNextSharp />
                                    </Icon>
                                ) : null}
                            </Box>
                            <SubNavList
                                anchorElSubNav={anchorElchildNav}
                                handleCloseSubNav={handleCloseSubNav}
                                subNavOpen={activeSubNavId === item.id}
                                list={item.subEntityTypes}
                            />
                        </React.Fragment>
                    ))}
                </MenuList>
            </Paper>
        </Popper>
    )
}

export default SubNavList
